
















































import { defineComponent, computed, ref } from "@vue/composition-api";
import { useTranslate } from "@lang";

export default defineComponent({
	props:{
		studyId:{
			type:String,
			required:true,
		},
		enabled:{
			type:Boolean,
			default:false,
		}
	},
	setup(props){


		const { translate } = useTranslate();

		const urlBox = ref<HTMLInputElement>();

		const url = computed(() => {
			return `${window.location.origin}/p/s/${props.studyId}`;
		});

		const copy = () => {

			console.log(urlBox);
			if(!urlBox.value){ return; }
			urlBox.value.select();
			document.execCommand("copy");
		};

		return {
			url,
			urlBox,
			copy,
			translate,
		};
	}
});

